var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"300"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{attrs:{"color":_vm.dialogColor,"dark":""}},[_c('v-card-text',[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }